import React from 'react';
import PropTypes from 'prop-types';

import { studentGradesType } from '../../types';

import GradeCell from '../GradeCell';

import {
  Container,
  AssignmentColumn,
  Header,
} from './AssignmentsColumn.styled';

const AssignmentsColumn = ({
  studentGrades,
  assignments,
  launchTurnitinAssignment,
}) => (
  <Container>
    {assignments.map((assignment) => {
      const { id, title } = assignment;
      return (
        <AssignmentColumn key={id} totalAssignments={assignments.length}>
          <Header>{title}</Header>
          {studentGrades.map(({ assignmentGrades, studentId }) => (
            <GradeCell
              key={`${id}-${studentId}`}
              assignmentGrades={assignmentGrades}
              assignment={assignment}
              launchTurnitinAssignment={launchTurnitinAssignment}
            />
          ))}
        </AssignmentColumn>
      );
    })}
  </Container>
);

AssignmentsColumn.propTypes = {
  studentGrades: PropTypes.arrayOf(studentGradesType).isRequired,
  assignments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  launchTurnitinAssignment: PropTypes.func.isRequired,
};

export default AssignmentsColumn;
